shadow$provide[500] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, compile:{enumerable:true, get:function() {
  return compile;
}}});
const compile = function(program) {
  const {code, signatures} = program;
  const placeholders = replaced(signatures);
  const assembler = string_compiler(code, placeholders);
  return [signatures, assembler];
};
const replaced = function(signatures) {
  const out = {};
  const s = sig => out[sig.name] = true;
  s(signatures.main);
  for (const key of ["external", "internal", "varying", "uniform", "attribute",]) {
    for (const sig of signatures[key]) {
      s(sig);
    }
  }
  return out;
};
const string_compiler = function(code, placeholders) {
  let key;
  const re = new RegExp("\\b(" + (() => {
    const result = [];
    for (key in placeholders) {
      result.push(key);
    }
    return result;
  })().join("|") + ")\\b", "g");
  code = code.replace(/\/\/[^\n]*/g, "");
  code = code.replace(/\/\*([^*]|\*[^/])*\*\//g, "");
  return function(prefix, exceptions, defines) {
    let key;
    if (prefix == null) {
      prefix = "";
    }
    if (exceptions == null) {
      exceptions = {};
    }
    if (defines == null) {
      defines = {};
    }
    const replace = {};
    for (key in placeholders) {
      replace[key] = exceptions[key] != null ? key : prefix + key;
    }
    const compiled = code.replace(re, key => replace[key]);
    const defs = (() => {
      const result1 = [];
      for (key in defines) {
        const value = defines[key];
        result1.push(`#define ${key} ${value}`);
      }
      return result1;
    })();
    if (defs.length) {
      defs.push("");
    }
    return defs.join("\n") + compiled;
  };
};

};